import ProjetosAcompanhamento from "../projetos/Acompanhamento";

export default function TarefasSetup() {
  return <ProjetosAcompanhamento tipo={2} titulo="Acompanhamento de Tarefas" />;
}
